import React from "react";
import { Doughnut } from "react-chartjs-2";
import numeral from "numeral"; 

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartData,
  ChartOptions,
} from "chart.js";

numeral.register("locale", "es-ES", {
  delimiters: {
    thousands: ".", 
    decimal: ",",   
  },
  abbreviations: {
    thousand: "k",
    million: "M",
    billion: "B",
    trillion: "T",
  },
  ordinal: (number: number) => {
    return number === 1 ? "er" : "o";
  },
  currency: {
    symbol: "$",
  },
});

numeral.locale("es-ES");

ChartJS.register(ArcElement, Tooltip, Legend);

interface DoughnutChartProps {
  chartData: ChartData<"doughnut">;
  cajasBase: number;
  totalContratado?: number;
}

const DoughnutChart: React.FC<DoughnutChartProps> = ({ chartData, cajasBase, totalContratado }) => {
  let total = chartData.datasets[0].data[1] === -1 ? 0 : Number(chartData.datasets[0].data.reduce((a, b) => a + b, 0)); 
  let cumplimiento = chartData.datasets[0].data[0]; 

  // Calcular el porcentaje real
  let porcentajeCumplimientoReal = 0;
  if (totalContratado && totalContratado > 0) {
    porcentajeCumplimientoReal = (cajasBase / totalContratado) * 100;
    if (porcentajeCumplimientoReal > 100) porcentajeCumplimientoReal = 100;
  }

  total = isNaN(total) ? 0 : Math.abs(total);
  cumplimiento = isNaN(cumplimiento) ? 0 : Math.abs(cumplimiento);

  const formatNumber = (number: number) => {
    if (isNaN(number)) return "0"; 
    return numeral(number).format('0,0'); 
  };
  
  const options: ChartOptions<"doughnut"> = {
    plugins: {
      tooltip: {
        enabled: true, 
        caretPadding: 10,
        yAlign: "bottom",
        callbacks: {
          label: function (context) {
            // Mostrar siempre cajasBase para Cumplimiento
            if (context.label === "Cumplimiento") {
              return `${context.label}: ${formatNumber(cajasBase)}`;
            }
            const value = Number(context.raw) || 0; 
            const formattedValue = formatNumber(value); 
            return `${context.label}: ${formattedValue}`;
          },
        },
      },
      legend: {
        display: false,
      },
    },
    cutout: "90%",
    circumference: 180,
    rotation: -90,
  };
  return (
    <div className="flex flex-col items-center justify-center w-full" style={{ marginTop: "-50px" }}>
      <Doughnut data={chartData} options={options} className="h-full w-full" />
      <div style={{ marginTop: "-110px" }} className="text-center">
        <p className="text-xl font-bold text-gray-500">Cajas Base</p>
        <p className="text-3xl font-bold mb-2">
          {formatNumber(cajasBase)} 
        </p>        <div className="flex justify-center items-center">
          <div
            style={{
              width: "10px",
              height: "10px",
              backgroundColor: "#00BFFF",
              borderRadius: "50%",
              marginRight: "5px",
            }}
          ></div>
          <p style={{ margin: 0 }}>
            <span className="font-bold mr-4">{Math.floor(porcentajeCumplimientoReal)}%</span>{" "}
            <span className="text-gray-500">Cumplimiento</span>
          </p>
        </div>
      </div>
      <div className="w-full flex flex-row justify-between items-center mt-3">
        <p className="font-bold text-gray-500">Total Contratado</p>
        <p className="font-bold text-xl">{formatNumber(total)}</p> 
      </div>
    </div>
  );
};

export default DoughnutChart;
